import { Formik, FormikValues } from "formik"

import { useDOCLabelFormView } from './components/DOCLabelFormContextProvider';
import { IDOCLabelApplication, schemaDOCLabelApplication, processDLMPayload } from './core';
import { doFormSubmit } from "../../../../../../components/helpers";
import { useQueryClient } from 'react-query';
import { DOCLabelRequestModalForm } from "./components";
import { getLastPathFromWorkflow } from "../../../_helpers";

const DOCLabelRequestModalContent = () => {

  const { initValues, submitFn, onSuccess, dlmTypeCode } = useDOCLabelFormView();
  const { requestId, requestMode, appType, certID, model: productModel, dlmTypeId} = initValues;

  // refresh queries
  const queryClient = useQueryClient();
  const refreshDLMQueries = (id: number) => {
    queryClient.invalidateQueries(['DLMAPPLICATIONS-LIST', { lastpath: getLastPathFromWorkflow(appType)}]);
    queryClient.invalidateQueries(['DLMAPPLICATIONS-LIST', { listmode: 'own'} ]);
    if (id) {
      queryClient.invalidateQueries(['DLMAPPLICATION-LOAD', { dlmappid: id } ]);
    }
  }

  const doSubmit = async (values: IDOCLabelApplication, actions: FormikValues) => {

    const { setStatus, setSubmitting } = actions;

    const payload = processDLMPayload(values, requestId, requestMode, appType,dlmTypeId, certID, dlmTypeCode);  

    // @ts-ignore
    await doFormSubmit(submitFn, payload, setStatus, setSubmitting, (res) => {
      if (Object.hasOwn(payload, 'id')) {
        // @ts-ignore
        refreshDLMQueries(payload.id);
      }
      if (onSuccess) {
        onSuccess(res);
      }
    });
  }

  if (! (appType && productModel)) {
    return null;
  }

  return (
    <Formik
      initialValues={initValues}
      validationSchema={schemaDOCLabelApplication}
      validateOnChange={true}
      enableReinitialize={true}
      onSubmit={doSubmit}
      component={DOCLabelRequestModalForm}
    />
  )
}


export {DOCLabelRequestModalContent}